module.exports = __webpack_public_path__ + "static/media/facebook_tile.943159e7.jpg";